import actions from './actions';
import * as vistacartApi from '../../apis/vistacartApi';
import * as pricingContextApi from '../../apis/pricingContextApi';
import { cartSelectors } from '../cart';
import pricingSelectors from './selectors';
import {
  couponEntered,
  couponRemoved,
  couponApplied,
  couponDenied,
} from '../../apis/trackingApi';
import {
  noticeError,
  trackDiscountCodeSaveError,
  trackDiscountCodeClearError,
} from '../../apis/newRelicTracking';

const applyCouponWithContext = async (
  newCoupon,
  tenant,
  shopperId,
  isAnonymousUser
) => {
  const coupon = { id: newCoupon };
  const setCouponCodeResponse = await pricingContextApi.setBrowserCouponCode({
    coupon,
    tenant,
    shopperId,
    isAnonymousUser,
  });
  if (!setCouponCodeResponse?.couponApplied) {
    // future: get "validationErrors" from setCouponCodeAction and use that for messaging...
    const error = new Error(
      `Coupon not applied - couponErrorMessageKey: ${setCouponCodeResponse?.couponErrorMessageKey}`
    );
    error.couponErrorMessageKey = setCouponCodeResponse?.couponErrorMessageKey;
    throw error;
  }
  await vistacartApi.refreshPricing(tenant, shopperId);
};

const setCoupon =
  (newCoupon, isAnonymousUser) => async (dispatch, getState) => {
    const { cart, pricing } = getState();
    dispatch(actions.SET_COUPON_START());
    couponEntered(newCoupon, cart);
    const tenant = cartSelectors.selectTenant(cart);
    const shopperId = cartSelectors.selectShopperId(cart);
    try {
      await applyCouponWithContext(
        newCoupon,
        tenant,
        shopperId,
        isAnonymousUser
      );
      dispatch(actions.SET_COUPON_SUCCESS());
      couponApplied(newCoupon, cart, pricing);
    } catch (error) {
      if (!error.nrReporterSource && !error.couponErrorMessageKey) {
        noticeError({ error, shopperId, tenant });
      }
      trackDiscountCodeSaveError(
        error,
        shopperId,
        tenant,
        newCoupon,
        error.couponErrorMessageKey
      );
      couponDenied(newCoupon, cart, pricing);
      dispatch(actions.SET_COUPON_FAIL(error, newCoupon));
      return { isSuccess: false, error };
    }
  };

const clearCoupon = () => async (dispatch, getState) => {
  const { cart, pricing } = getState();
  dispatch(actions.CLEAR_COUPON_START());
  const shopperId = cartSelectors.selectShopperId(cart);
  const tenant = cartSelectors.selectTenant(cart);
  try {
    await applyCouponWithContext('', tenant, shopperId);
    const couponBeingRemoved = pricingSelectors.selectDiscountCodeName(pricing);
    couponRemoved(couponBeingRemoved, cart, pricing);
    dispatch(actions.CLEAR_COUPON_SUCCESS());
  } catch (error) {
    error.couponErrorMessageKey = 'promoCodeClearFailed';
    if (!error.nrReporterSource) {
      noticeError({ error, shopperId, tenant });
    }
    trackDiscountCodeClearError(error, shopperId, tenant);
    dispatch(actions.CLEAR_COUPON_FAIL(error));
    return { isSuccess: false, error };
  }
};

export default {
  setCoupon,
  clearCoupon,
};
